export default __webpack_public_path__ + "static/media/four.26faca48.ogg";